import { useIlamyCalendarContext } from '@ilamy/calendar';
import dayjs from 'dayjs';
import { useEffect, useRef } from 'react';

import type { SchedulerView } from './scheduler.types.js';

export function SchedulerDateSync({ date, view }: Readonly<{ date: Date; view: SchedulerView }>) {
  const { currentDate, view: currentView, setCurrentDate, setView } = useIlamyCalendarContext();
  const lastDateTime = useRef(date.getTime());
  const lastView = useRef(view);

  useEffect(() => {
    const dateChanged = lastDateTime.current !== date.getTime();
    const viewChanged = lastView.current !== view;
    lastDateTime.current = date.getTime();
    lastView.current = view;
    if (viewChanged && currentView !== view) {
      setView(view, dateChanged ? dayjs(date) : undefined);
      return;
    }
    if (dateChanged && !currentDate.isSame(dayjs(date), 'day')) {
      setCurrentDate(dayjs(date));
    }
  }, [date, view, currentDate, currentView, setCurrentDate, setView]);

  return null;
}
